export const FETCH_ACTIVE_BANNER_RESOLVED = "FETCH_ACTIVE_BANNER_RESOLVED";
